import app from 'flarum/forum/app';

/**
 * O link de cadastro do e-mail volta para o fórum com o token na sessão (nunca
 * na URL); o servidor o entrega no payload uma vez e aqui o SignUpModal abre.
 */
export default function openPendingRegistration() {
  const pending = app.data.magicLinkRegistration;
  if (!pending?.token) return;

  // Depois do app.mount(), quando o gerenciador de modais já existe.
  setTimeout(() => {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'), {
      token: pending.token,
      email: pending.email || '',
      username: pending.username || '',
      provided: ['email']
    });
  }, 0);
}